const SearchResultActions = {
    // this is unlikely to be what you want. Check out SearchFormActions
    START_SEARCH: "search-result/start-search",

    SEARCH_RESULT: "search-result/search-result",
    SEARCH_ERROR: "search-result/search-error",
    RESET_SEARCH: "search-result/reset-search",
};

export default SearchResultActions;



// WEBPACK FOOTER //
// ./app/data/SearchResultActions.js